function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj || {}, key);
}

function clean(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function profilName(profil) {
  return `${profil?.vorname || ''} ${profil?.nachname || ''}`.trim() || profil?.name || '';
}

function profilAnschrift(profil) {
  return [
    [profil?.strasse, profil?.hausnummer].filter(Boolean).join(' '),
    [profil?.plz, profil?.ort].filter(Boolean).join(' '),
  ].filter(Boolean).join('\n');
}

const PLZ_REGEX = /\b\d{5}\b/;

export function buildAnschreibenAbsender(stelle, profil) {
  // If absender_name contains a postal code, it was corrupted by a display glitch — fall back to profil
  const korrupt = hasOwn(stelle, 'absender_name') && PLZ_REGEX.test(clean(stelle.absender_name));

  const name = (!korrupt && hasOwn(stelle, 'absender_name'))
    ? clean(stelle.absender_name)
    : clean(profilName(profil));
  const anschrift = (!korrupt && hasOwn(stelle, 'absender_anschrift'))
    ? clean(stelle.absender_anschrift)
    : clean(profilAnschrift(profil));
  const telefon = (!korrupt && hasOwn(stelle, 'absender_telefon'))
    ? clean(stelle.absender_telefon)
    : clean(profil?.telefon);
  const email = (!korrupt && hasOwn(stelle, 'absender_email'))
    ? clean(stelle.absender_email)
    : clean(profil?.email);

  return { name, anschrift, telefon, email };
}

export function anschreibenAbsenderZeilen(stelle, profil) {
  const absender = buildAnschreibenAbsender(stelle, profil);
  return [
    absender.name,
    ...absender.anschrift.split('\n').map(clean).filter(Boolean),
    absender.telefon,
    absender.email,
  ].filter(Boolean);
}
